import { awsStoreService } from '@/shared/lib/aws-store';
import { FileInfo } from '@/widgets/modals/containers/FilePreviewModal/FilePreview';

export const INTERWILL_LANGUAGES = [
  'en',
  'es',
  'ru',
  'zh',
  'ar',
  'fr',
  'pt',
  'it',
  'tr',
  'pl',
  'ko',
  'ro',
  'el',
  'hu',
];

export enum TemplateType {
  TESTATOR_ATTESTATION = 'testator-attestation',
  WILL_CERTIFICATE = 'will-certificate',
  DEMO_WILL = 'will-demo',
  DEMO_WILL_UNSIGNED = 'will-demo-unsigned',
  WITNESS_VERIFICATION_1 = 'witness_verification_1',
  WITNESS_VERIFICATION_2 = 'witness_verification_2',
  WITNESS_VERIFICATION_3 = 'witness_verification_3',
}

export const TEMPLATE_FILES: Record<TemplateType, FileInfo> = {
  [TemplateType.TESTATOR_ATTESTATION]: {
    fileType: 'pdf',
    name: 'testator-attestation.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/testator-attestation.pdf`),
    size: 73.6,
  },
  [TemplateType.WILL_CERTIFICATE]: {
    fileType: 'pdf',
    name: 'will-certificate.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/will-certificate.pdf`),
    size: 401,
  },
  [TemplateType.DEMO_WILL]: {
    fileType: 'pdf',
    name: 'My_InterWill_file.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/LAST WILL AND TESTAMENT of Martin Y.pdf`),
    size: 4932.15,
  },
  [TemplateType.DEMO_WILL_UNSIGNED]: {
    fileType: 'pdf',
    name: 'My_InterWill_file.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/LAST WILL AND TESTAMENT W-K5XT9.pdf`),
    size: 4805.73,
  },
  [TemplateType.WITNESS_VERIFICATION_1]: {
    fileType: 'pdf',
    name: 'Verification of Witnesses “1”.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/WITNESS STATEMENT.pdf - Page 1 of 3.pdf`),
    size: 447,
  },
  [TemplateType.WITNESS_VERIFICATION_2]: {
    fileType: 'pdf',
    name: 'Verification of Witnesses “2”.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/WITNESS STATEMENT.pdf - Page 2 of 3.pdf`),
    size: 341,
  },
  [TemplateType.WITNESS_VERIFICATION_3]: {
    fileType: 'pdf',
    name: 'Verification of Witnesses “3”.pdf',
    url: awsStoreService.getDocObjectUrl(`interwill/WITNESS STATEMENT.pdf - Page 3 of 3.pdf`),
    size: 310,
  },
};
